import type { RootState } from "../reducers/root.reducer"
import type { ICalculatorState } from "../types/state.types"

export const calculatorSelector = (state: RootState): ICalculatorState =>
    state.calculator
